import styled from 'styled-components'

const SheetContainer = ({ children }) => {
  return (
    <S_SheetContainer>
      {
        children
      }
    </S_SheetContainer>
  )
}

export default SheetContainer

const S_SheetContainer = styled.div`
  width: calc(100% - 2rem);
  padding: 0 1rem;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`